module.exports = __webpack_public_path__ + "img/9161ef6596d15184e4b17970efe5d49c.png";